import { BehaviorSubject } from 'rxjs';

export class ModalControl {
  isOpen$ = new BehaviorSubject(false);

  constructor(isOpen?: boolean) {
    if (isOpen) {
      this.open();
    }
  }

  get isOpened(): boolean {
    return this.isOpen$.getValue();
  }

  close(): void {
    this.isOpen$.next(false);
  }

  open(): void {
    this.isOpen$.next(true);
  }

  toggle(): void {
    this.isOpen$.next(!this.isOpen$.getValue());
  }
}
